import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "CasinoPlayerGamesWidget" */ './CasinoPlayerGamesWidget'),
  modules: ['./CasinoPlayerGamesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
